import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import moment from 'moment-timezone';
import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';
import { ALL_TIME, CUSTOM_RANGE, RELATIVE_DATE_PRESETS_WITH_ALL_TIME } from 'ui/datePicker/helpers';
import { DATE_FORMAT_TRUNC_YEAR as truncYear, displayDate, getFromNow } from 'utils/date';
import { MergedCustomEvent } from '../types';

export const formatPreset = (preset: string): string => {
  const presets = RELATIVE_DATE_PRESETS_WITH_ALL_TIME as { [key: string]: any };
  return presets?.[preset]?.filterLabel || '';
};

export const formatDateRange = (preset: string, start: string, end: string) =>
  preset === CUSTOM_RANGE
    ? `${displayDate(moment(start), truncYear)}-${displayDate(moment(end), truncYear)}`
    : formatPreset(preset);

export const createQueryString = (preset: string, start: string, end: string) =>
  preset !== ALL_TIME && start && end ? `?start=${start}&end=${end}` : '';

export const formatReferences = (count: number, term: string) => {
  const word = count === 1 ? term : `${term}s`;
  return `${count} ${word}`;
};

export const convertToDays = (value: string, duration: 'days' | 'years'): number => {
  const numValue = Number(value);
  if (duration === 'years') {
    return Math.round(numValue * 365);
  }

  return Math.round(numValue);
};

export const formatLastSeen = (timestamp: number) => (!timestamp ? 'Never' : getFromNow(timestamp));

export const groupSelectStatus = (count: number, totalCount: number) => {
  if (count === 0) return CHECKBOX_STATUS.UNCHECKED;
  if (count === totalCount) return CHECKBOX_STATUS.CHECKED;
  return CHECKBOX_STATUS.INDETERMINATE;
};

/**
 * Sort custom events
 * sorting was not accurate once "name" was selected
 * it was showing capital letters before lowercase letters
 */
export const sortCustomEvents = (
  customEvents: MergedCustomEvent[] = [],
  sortBy: string,
  sortDirection: SORT_DIRECTIONS,
) => {
  const isAscending = sortDirection === SORT_DIRECTIONS.ASCENDING;

  const sorted = customEvents.sort((eventA: MergedCustomEvent, eventB: MergedCustomEvent) => {
    const sortByAsKey = sortBy as keyof MergedCustomEvent;
    const propertyA = eventA[sortByAsKey].toString().toLowerCase();
    const propertyB = eventB[sortByAsKey].toString().toLocaleLowerCase();
    return propertyA.localeCompare(propertyB, 'en-US', { numeric: true });
  });

  return isAscending ? sorted : sorted.reverse();
};

export * from './ingestionPolicy';
export * from './retentionPeriod';
